export default "__VITE_ASSET__DMHkP77e__"